import styled from "styled-components";
import { Paragraph2, WhiteContainer } from "../../components";
import { colors } from "../../consts";

export const FormSectionWrapper = styled(WhiteContainer)`
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px 24px 16px 24px;
  width: 100%;
`;

export const Title = styled(Paragraph2)`
  font-weight: 700;

  color: ${(props) => (props?.hasError ? colors.ERROR : colors.RAISIN_100)};
`;

export const InfoText = styled(Paragraph2)`
  font-size: 12px;
  line-height: 18px;
  color: ${colors.RAISIN_80};
`;
